import './hampshirehe3/style';
import FormStructure from './hampshirehe3/form_structure';

export default FormStructure;